<template>
    <section id="page-contact" class="page page-contact">
        <div class="page__content">
            <div class="container">
                <div class="row">
                    <div class="col-4-sm col-2"></div>
                    <div class="col-4-sm col-8">
                        <div class="page__icon-wrapper">
                            <i class="far fa-address-card" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4-sm col-2"></div>
                    <div class="col-12-sm col-8">
                        <h1>Leuk dat je interesse hebt in het hybride docentschap!</h1>
                        <p class="page-contact__intro">Graag sturen we je jouw persoonlijke profiel toe, inclusief informatie op <u>maat</u> over vervolgstappen die je kunt nemen om het hybride docentschap in de praktijk te gaan brengen.
                        </p>
                    </div>
                </div>

                <!--<form>-->
                    <!-- opMaat -->
                    <div class="row">
                        <div class="col-12-sm col-2"></div>
                        <div class="col-12-sm col-8">
                            <div class="page-contact__select-question">
                                Wil je jouw persoonlijke profiel en aanvullende informatie op maat ontvangen?
                            </div>
                            <div class="push-buttons">
                                <div class="push-button" v-on:click="booleanButtonHandler('opMaat', true, $event)"
                                    v-bind:class="{'push-button--selected':opMaat}">Ja
                                </div><div class="push-button" v-on:click="booleanButtonHandler('opMaat', false, $event)"
                                    v-bind:class="{'push-button--selected':!opMaat}">Nee
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="opMaat">
                        <div class="row row--form-item">
                            <div class="col-12-sm col-2"></div>
                            <div class="col-12-sm col-8">
                                <div class="page-contact__form-title">Naam</div>
                                <input id="input-naam" tabindex="1"
                                       type="text" class="typeahead__input" v-model="naam">
                            </div>
                        </div>

                        <div class="row row--form-item">
                            <div class="col-12-sm col-2"></div>
                            <div class="col-12-sm col-8">
                                <div class="page-contact__form-title">E-mailadres</div>
                                <input id="input-email" tabindex="2"
                                       type="email" class="typeahead__input" v-model="email" ref="input-email">
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12-sm col-2"></div>
                        <div class="col-12-sm col-8">
                            <p>Bedankt! Meer informatie is te vinden op <a href="http://www.hybridedocent.nl" target="_blank">www.hybridedocent.nl</a></p>
                        </div>
                    </div>

                    <!-- opMaat -->
                    <div class="row" v-if="opMaat">
                        <div class="col-12-sm col-2"></div>
                        <div class="col-12-sm col-8">
                            <div class="page-contact__select-question">
                                Wil je in de toekomst op de hoogte worden gebracht als er in jouw regio projecten starten op het gebied van hybride docentschap?                            </div>
                            <div class="push-buttons">
                                <div class="push-button" v-on:click="booleanButtonHandler('opDeHoogteBrengenProjecten', true, $event)"
                                    v-bind:class="{'push-button--selected':opDeHoogteBrengenProjecten}">Ja
                                </div><div class="push-button" v-on:click="booleanButtonHandler('opDeHoogteBrengenProjecten', false, $event)"
                                    v-bind:class="{'push-button--selected':!opDeHoogteBrengenProjecten}">Nee
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="opMaat && opDeHoogteBrengenProjecten">
                        <div class="row row--form-item">
                            <div class="col-12-sm col-2"></div>
                            <div class="col-12-sm col-8">
                                <div class="page-contact__form-title">Woonplaats</div>
                                <input id="input-woonplaats" tabindex="3" ref="input-woonplaats"
                                       type="text" class="typeahead__input" v-model="woonplaats">
                            </div>
                        </div>

                        <div class="row row--form-item">
                            <div class="col-12-sm col-2"></div>
                            <div class="col-12-sm col-8">
                                <div class="page-contact__form-title">Opleiding</div>
                                <input id="input-opleiding" tabindex="4" ref="input-opleiding"
                                       type="text" class="typeahead__input" v-model="opleiding">
                            </div>
                        </div>

                        <div class="row row--form-item">
                            <div class="col-12-sm col-2"></div>
                            <div class="col-12-sm col-8">
                                <div class="page-contact__form-title">Huidige functie</div>
                                <input id="input-functie" tabindex="5" ref="input-functie"
                                       type="text" class="typeahead__input" v-model="huidigeFunctie">
                            </div>
                        </div>
                    </div>

                    <!--<div class="row" v-if="opMaat && !opDeHoogteBrengenProjecten"-->
                         <!--style="margin-top: 15px; margin-bottom: 15px; font-family: FranklinGothicDemi;">-->
                        <!--<div class="col-12-sm col-2"></div>-->
                        <!--<div class="col-12-sm col-8">-->
                            <!--<p>Bedankt! Houd <a href="http://www.hybridedocent.nl" target="_blank">www.hybridedocent.nl</a> in de gaten voor</p>-->
                        <!--</div>-->
                    <!--</div>-->


                    <!-- Nieuwsbrief -->
                    <div class="row" v-if="opMaat">
                        <div class="col-12-sm col-2"></div>
                        <div class="col-12-sm col-8">
                            <div class="page-contact__select-question">
                                Wil je in de toekomst op de hoogte worden gehouden via onze nieuwsbrief?
                            </div>
                            <div class="push-buttons">
                                <div class="push-button" v-on:click="booleanButtonHandler('nieuwsbrief', true, $event)"
                                    v-bind:class="{'push-button--selected':nieuwsbrief}">Ja
                                </div><div class="push-button" v-on:click="booleanButtonHandler('nieuwsbrief', false, $event)"
                                    v-bind:class="{'push-button--selected':!nieuwsbrief}">Nee</div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <div class="row" v-if="errors && submitAttempt">
                        <div class="col-12-sm col-2">
                        </div>
                        <div class="col-12-sm col-8">
                            <p v-for="error in errors">{{error}}</p>
                        </div>
                    </div>
                    <div class="row" v-if="opMaat">
                        <div class="col-12-sm col-2">
                        </div>
                        <div class="col-12-sm col-8">
                            <button tabindex="6"
                                    class="button" v-on:click="aanvragenHandler($event)">Verstuur</button>
                            <div v-if="submitPending" class="fa-3x" style="margin-top: 15px;">
                                <i class="fa fa-spinner fa-spin"></i>
                            </div>
                        </div>
                    </div>
                <!--</form>-->
            </div>
        </div>

    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-contact__intro
        margin-bottom 30px

    .page-contact__select-question
        margin 1em 0 .6em 0
        line-height 1.6em

    .page-contact__form-title
        text-align left
        margin-bottom .4em

</style>
<script>
    import _ from 'lodash';
    import page from './page';

    export default {
        mixins: [page],
        props: {
            userProfile: {
                type: Object,
                default: {}
            },
            submitPending: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
               // inleidingHeeftBevoegdheid: 'Yes! Je bent klaar om te starten als Hybride Docent. Wat nu? Als je onderstaande gegevens invult sturen we ons advies over jouw mogelijke vervolgstappen.',
               // inleidingGeenBevoegdheid: 'Om te starten als Hybride Docent moet je eerst je lesbevoegdheid halen. Wat nu? Als je onderstaande gegevens invult sturen we ons advies over jouw mogelijke vervolgstappen. We hopen je snel te zien als de volgende Hybride Docent!',
                opMaat: true,
                opDeHoogteBrengenProjecten: true,
                nieuwsbrief: true,
                naam: '',
                email: '',
                woonplaats: '',
                opleiding: '',
                huidigeFunctie: '',
                submitAttempt: false,
                errors: false
            }
        },
        watch: {
            opMaat() {
                this.formInputChanged();
            },
            opDeHoogteBrengenProjecten() {
                this.formInputChanged();
            },
            naam() {
                this.formInputChanged();
            },
            email() {
                this.formInputChanged();
            },
            woonplaats() {
                this.formInputChanged();
            },
            opleiding() {
                this.formInputChanged();
            },
            huidigeFunctie() {
                this.formInputChanged();
            }
        },
        computed: {
            inleiding() {
                return this.userProfile.baan1 === 'Leraar' || this.userProfile.bevoegdheid ? this.inleidingHeeftBevoegdheid : this.inleidingGeenBevoegdheid;
            }
        },
        methods: {
            booleanButtonHandler(key, isSet, event) {
                console.log('booleanButtonHandler');
                this[key] = isSet;
            },
            formValuesValid() {
                const errors = [];
                const opMaatValid = (this.opMaat && this.isValidFormValue('naam', errors) && this.isValidFormValue('email', errors)) || !this.opMaat;
                const opDeHoogteBrengenValid = (this.opDeHoogteBrengenProjecten && this.isValidFormValue('woonplaats', errors) && this.isValidFormValue('opleiding', errors) && this.isValidFormValue('huidigeFunctie', errors)) ||  !this.opMaat || !this.opDeHoogteBrengenProjecten;
                return opMaatValid && opDeHoogteBrengenValid ? true : errors;
            },
            isValidFormValue(property, errors) {
                let isValid;
                const cleanValue = _.trim(this[property]);
                let newError;
                switch(property) {
                    case 'email':
                        /* https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email */
                        const regexp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                        isValid = regexp.test(cleanValue);
                        if (!isValid) {
                            newError = 'Ongeldig e-mailadres.'
                        }
                        break;
                    default:
                        isValid = cleanValue.length > 0;
                        if (!isValid) {
                            newError = 'Vul alle velden in.'
                        }
                }
                if (newError && errors.indexOf(newError) === -1) {
                    errors.push(newError);
                }
                return isValid;
            },
            aanvragenHandler(event) {
                event.preventDefault();
                this.submitAttempt = true;
                this.errors = null;
                const validation = this.formValuesValid();
                if (validation === true) {
                    this.$emit('profileupdate', [
                        { key: 'opMaat', value: this.opMaat },
                        { key: 'opDeHoogteBrengenProjecten', value: this.opDeHoogteBrengenProjecten },
                        { key: 'nieuwsbrief', value: this.nieuwsbrief },
                        { key: 'naam', value: this.naam },
                        { key: 'email', value: this.email },
                        { key: 'woonplaats', value: this.woonplaats },
                        { key: 'huidigeFunctie', value: this.huidigeFunctie },
                        { key: 'opleiding', value: this.opleiding }
                    ]);
                    this.nextHandler();
                } else {
                    this.errors = validation;
                }
            },
            formInputChanged() {
                this.submitAttempt = false;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// page-contact.vue?c4fed396